import BaselineRenderer from "./BaselineRenderer";
import {Baseline} from "./BaselineEditor";
import React, { useRef, useState, useEffect } from 'react';
import baselineParse from './baselineParse';
function getVerticalAlign(angle){
  if (angle < 0) {
    return "flex-end";
  } else if (angle > 0) {
    return "flex-start";
  } else {
    return "center";
  }
}



export function getTextTranslation(tdBounds, originalBounds, bounds, angle, rotatedRectHeight){
  let theta = Math.abs((Math.PI * 2 * angle) / 360);

  let textTopTranslation;

  if( tdBounds.height <= rotatedRectHeight ){
    textTopTranslation = angle > 0 ? -(tdBounds.height * (1 - Math.cos(theta))) : 0;
  }else{
    textTopTranslation = 0 ;
  }

  let sign = angle < 0 ? 1 : -1;

  let offset = angle > 0 ? -1 : 0;
  let left = offset + tdBounds.width / 2 + sign * (originalBounds
    ? ((originalBounds.height - 2) * Math.sin(theta)) / 2
    : 0);

  let textLeftTranslation = angle !== 0 ? left : bounds.left;
  return { textLeftTranslation, textTopTranslation };

}


export default React.memo(function FigureText({
  textStyle,
  value,
  cell,
  cellLocation,
  tdRef,
  textBounds,
  rotatedRectHeight,
  dontRotate,
  showHtmlProps,
}){



  let tdBounds = tdRef && tdRef.current && tdRef.current.getBoundingClientRect() || {};

  const ref = useRef(null);
  const [bounds, setBounds] = useState({});


  let originalBounds = textBounds;

  let angleDirection = cell.data.style.angleDirection;
  let directionSign = ({up:-1, down:1})[angleDirection] || -1;
  let angle = directionSign * cell.data.style.angle || 0;
  if (dontRotate) angle = 0;

  //if (angle > 0) {
  //  if (Math.abs(angle - 45) < Math.min(Math.abs(angle), Math.abs(90 - angle))) angle = 45;
  //} else {
  //  if (Math.abs(angle - (-45)) < Math.min(Math.abs(angle), Math.abs((-90) - angle))) angle = -45;
  //}

  useEffect(() => {
    let newBounds = ref.current.getBoundingClientRect();
    setBounds(newBounds);
  }, [ref, angle]);

  let { textTopTranslation, textLeftTranslation } = getTextTranslation(
    tdBounds, originalBounds, bounds, angle, rotatedRectHeight
  );


  let lines = value.split('\n').map((val,iiLine) => {

    /*return (
      <div>{JSON.stringify(baselineParse(val))}</div>
    )*/


    

    let spans = <BaselineRenderer
      text={val}
      line={iiLine}
      cellLocation={cellLocation.join('-')}
      path={[0]}/>


    // let spans = Array.from(val).map( 
    //   (char,iiChar) => {
    //     let id = "char-"+iiChar+"-line-"+iiLine+"-grid-"+cellLocation.join('-');
    //     return <span 
    //       style={{
    //       }}
    //       id={id}>{char}</span>
    //   }
    // )

    let fontSize = cell.data.style.fontSize || 12;
    return (
      <div id={"line-"+iiLine+"-grid-"+cellLocation.join('-')} style={{
        fontSize,
        fontFamily:cell?.data?.style?.fontFamily,
      }} className="gridcellTextContainer">{spans}</div>
    )
  })


  const opts = [0,'50%','100%'];

  const index = { 0:0, '50%':1,'100%':2 };
  const xIndex = { left:0, center:1, right:2 };
  const yIndex = { top:0, middle:1, bottom:2 };


  let txyMap;
  if( angle === 90 || angle === 0 ){
    txyMap = [
      [ [0,2], [1,2], [2,2] ],
      [ [0,1], [1,1], [2,1] ],
      [ [0,0], [1,0], [2,0] ]
    ]

  }else if( angle === -90 ){
    txyMap = [
      [ [2,0], [1,0], [0,0] ],
      [ [2,1], [1,1], [0,1] ],
      [ [2,2], [1,2], [0,2] ]
    ]
  }

  let textAlign = textStyle.textAlign || "center";
  let verticalAlign = textStyle.verticalAlign || "middle";
  //const { textAlign="center", verticalAlign="middle" } = textStyle;

  let spaceX = opts[ xIndex[ textAlign ] ];
  let spaceY = opts[ yIndex[ verticalAlign ] ];

  let tetherX = spaceX;
  let tetherY = spaceY;

  if( Math.abs(angle) === 90 ){
    let optIndices = txyMap[ xIndex[textAlign] ][ yIndex[verticalAlign] ]
    if( !optIndices ){
      debugger;
    }
    let mappedTethers = optIndices.map(id => opts[id]);
    tetherX = mappedTethers[0];
    tetherY = mappedTethers[1];

  }
     

  const isGridAligned = angle === 0 || angle === 90 || angle === -90;
  let spanStyle = isGridAligned ? {} : {
    //position: "relative",
    zIndex: 2,
    padding: 0,
    margin: 0,
    top: (angle) !== 0 && textTopTranslation,
    left: (angle) !== 0 && textLeftTranslation,
    transform: "rotate(" + angle + "deg)",
    transformOrigin: "0% 100%",
    lineHeight: 1,
    whiteSpace: "nowrap",
  }

  let idWithGridAtTheBeginningAndCellLocationInfoSeparatedByDashesForSelectionFrameworkInManualAnnotationGrid = "grid_text_container-"+cellLocation.join('-')

  //let justifyContent = ({top:"flex-start",middle:"center",bottom:"flex-end"})[textStyle.verticalAlign]


  let pivotPointForSvg = (
    <div id={"pivot-point-"+cellLocation.join('-')}
      class={"DO-NOT-DELETE-NEEDED-FOR-SVG-GENERATION"} style={{
        position:'absolute', 
        //background:'magenta',
        width:3,height:3,
        borderRadius:5,
        zIndex:5,
        top:(angle!==0 ? textTopTranslation: 0) + (originalBounds && originalBounds.height),
        left:(angle!==0 ? textLeftTranslation:0),
      }}/>
  )

  
  let linesContainer = (
    <div 
      style={{
        //background:'lime',
        fontFamily:'Helvetica',
        fontSize:12,
        whiteSpace:'nowrap',
        position:'absolute',
        top:spaceY,
        left:spaceX,
        //outline:'1px solid blue',
        transformOrigin:`${tetherX} ${tetherY}`,
        transform:([0,90].includes(Math.abs(angle)) && (`translate(-${tetherX}, -${tetherY}) rotate(${angle}deg)`)),

        ...spanStyle,

        
        //position:(angle !== 0 && "absolute"),
      }}>
      {lines}

      {pivotPointForSvg}
    </div>
  )

  let selectableGridItem = (
    <div
      id={idWithGridAtTheBeginningAndCellLocationInfoSeparatedByDashesForSelectionFrameworkInManualAnnotationGrid}
      ref={ref}
      style={{
        background:'orange',
        //...spanStyle,
        //background:'orange',
      }}>
      {linesContainer}
    </div>
  )

  let htmlProps = showHtmlProps ? {cell:cellLocation.join('-'),objectType:"TextStyleContainer"} : {};


  if( value === "\\triangle/" ){

  return (
    <div ref={ref} style={{
      width:'100%',
      height:'100%',
      background:'black',
      clipPath: 'polygon(0% 100%, 100% 0%, 100% 100%)',

    }}>
    </div>
  )
  }else if( value === "\\triangle\\" ){

    return (

      <div style={{background:textStyle?.background}} class="full-dim" ref={ref}>
        <svg style={{position:'absolute', width:bounds.width, height:bounds.height}} preserveAspectRatio="none">
    <polygon points={`0,0 0,${bounds.height} ${bounds.width},${bounds.height}`} fill={textStyle?.color||"black"} />
  </svg>
      </div>
    )

    return (
    <div ref={ref} style={{
      width:'100%',
      height:'100%',
      background:'lime',
        //clipPath: 'polygon(0% 0%, 100% 100%, 0% 100%)',
        //background: 'linear-gradient(to top right, #3498db 50%, transparent 50%)',
      transform:'rotate(30deg)',



    }}>
    </div>
  )
  }

  return (

    <>

      {false && <div style={{
        position:'absolute',
        top:'50%',
        left:'50%',
        width:3,
        height:3,
        transform:'translate(-50%,-50%)',
        background:'cyan',
      }}/>}

      {(angle||null) && <div
        style={{
          pointerEvents:'none',
          zIndex: 10,
          position: "fixed",
          width: bounds.width,
          height: bounds.height,
          top:bounds.top,
          left: bounds.left
        }}
      />}

        <div
          {...htmlProps}
        style={{
            position:'absolute',
            top:0,
            left:0,

            margin: 0,
            width:'100%',
            height:'100%',
            ...textStyle,
          }}
          //class="sg-col"
        >
          
          {selectableGridItem}

          {false && <div style={{
            position:'absolute',
            top:0,
            left:0,
            fontSize:10,
          }}>{JSON.stringify({tx:tetherX,ty:tetherY})}</div>}

          
        </div>
        {false && <div style={{fontSize:8,position:'absolute',top:0,left:0,}}> {JSON.stringify(bounds||{},null,1)} </div>}
    </>
  )


})





